import { render, staticRenderFns } from "./videoDisplay.vue?vue&type=template&id=00ec63be&scoped=true"
import script from "./videoDisplay.vue?vue&type=script&lang=js"
export * from "./videoDisplay.vue?vue&type=script&lang=js"
import style0 from "./videoDisplay.vue?vue&type=style&index=0&id=00ec63be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ec63be",
  null
  
)

export default component.exports